import { Component } from 'solid-js';
import { TbRobot } from 'solid-icons/tb';
import { TbRocket } from 'solid-icons/tb';

interface NetworkLogoProps {
  network?: string;
  size?: number;
}

// Allowed networks
const ALLOWED_NETWORKS = ['trf', 'trz', 'imo', 'lospol', 'cldr','dtf','mtc', 'adv'];

const NetworkLogo: Component<NetworkLogoProps> = (props) => {
  const size = props.size || 24;
  const network = (props.network || '').toLowerCase().trim();

  const getLogoPath = () => {
    switch (network) {
      case 'trf':
        return '/trf_logo.png';
      case 'trz':
        return '/trz_logo.png';
      case 'lospol':
      case 'lp':
        return '/lp_logo.png';
      case 'imo':
        return '/imo_logo.png';
      case 'cldr':
        return '/cldr_logo.png';
      case 'dtf':
        return '/dtf_logo.png';
      case 'mtc':
        return '/mtc_logo.png';
      case 'adv':
        return '/adv_logo.png';
      default:
        return null;
    }
  };

  const logoPath = getLogoPath();

  // Show image if available
  if (logoPath) {
    return (
      <img
        src={logoPath}
        alt={network || 'network'}
        title={network || 'Network'}
        style={{
          width: `${size}px`,
          height: `${size}px`,
          'object-fit': 'contain',
        }}
        class="inline-block"
      />
    );
  }

  // Check if network is in allowed list
  const isAllowedNetwork = network && ALLOWED_NETWORKS.includes(network);

  // Fallback to TbRocket icon for unknown/invalid networks
  if (!isAllowedNetwork && network) {
    return (
      <div
        title={`Invalid network: ${network}`}
        class="inline-flex items-center justify-center text-amber-500 dark:text-amber-400"
        style={{
          width: `${size}px`,
          height: `${size}px`,
        }}
      >
        <TbRocket size={size} />
      </div>
    );
  }

  // Fallback to TbRobot icon when network has no image but is allowed
  return (
    <div
      title={network || 'Unknown network'}
      class="inline-flex items-center justify-center text-gray-500 dark:text-gray-400"
      style={{
        width: `${size}px`,
        height: `${size}px`,
      }}
    >
      <TbRobot size={size} />
    </div>
  );
};

export default NetworkLogo;
